/**
 * セット企画設定画面　セット企画プロモーション商品情報取得VOクラス
 */
export class KYMW1312GetSetPlanPromotionGoodsInfoModel {
  // 受注コード
  public orderCode: string = <string>'';

  // プロモーションＮＯ
  public promotionNo: string = <string>'';

  // プロモーション区分
  public promotionDiv: string = <string>'';

  // プロモーション名称
  public promotionName: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  // セット企画商品名
  public setDelivGoodsName: string = <string>'';

  // 生協コード
  public coopCode: string = <string>'';

  // 部門コード
  public classCode: string = <string>'';
}
